import { render, staticRenderFns } from "./RecognitionsTab.vue?vue&type=template&id=03b778a2&scoped=true"
import script from "./RecognitionsTab.vue?vue&type=script&lang=js"
export * from "./RecognitionsTab.vue?vue&type=script&lang=js"
import style0 from "./RecognitionsTab.vue?vue&type=style&index=0&id=03b778a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b778a2",
  null
  
)

export default component.exports